'use client';

import { useEffect, useState } from 'react';

const Copyright = () => {
	const [year, setYear] = useState(0);

	useEffect(() => {
		const currentYear = new Date().getFullYear();
		setYear(currentYear);
	}, []);

	return <div className='opacity-50'>&copy; {year} Habitat for Humanity of the Charlotte Region. All rights reserved.</div>;
};

export default Copyright;
